import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 20,
	viewBox: "0 0 10.0 20.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 A 10.0 10.0 0.0 0 1 0.0 20.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgCap;
